import { render, staticRenderFns } from "./dispatchRecord.vue?vue&type=template&id=e5a339de&scoped=true&"
import script from "./dispatchRecord.vue?vue&type=script&lang=js&"
export * from "./dispatchRecord.vue?vue&type=script&lang=js&"
import style0 from "./dispatchRecord.vue?vue&type=style&index=0&id=e5a339de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a339de",
  null
  
)

export default component.exports